import {
  convertDateByTimezone,
  formatToDate,
  formatToDateTimeShort,
} from '../date';

import { renderTextLineClamp } from './renderTextLineClamp';

export const renderDate = <Row extends object>(
  item: Row,
  field: keyof Row,
  timezoneOffset?: number
) => {
  const date = item[field];

  if (!(date instanceof Date)) {
    return null;
  }

  if (timezoneOffset !== undefined) {
    const timezoneDate = convertDateByTimezone(date, timezoneOffset);
    return renderTextLineClamp(formatToDate(timezoneDate));
  }

  return renderTextLineClamp(formatToDate(date));
};

export const renderDateTime = <Row extends object>(
  item: Row,
  field: keyof Row,
  timezoneOffset?: number
) => {
  const date = item[field];

  if (!(date instanceof Date)) {
    return null;
  }

  if (timezoneOffset !== undefined) {
    const timezoneDate = convertDateByTimezone(date, timezoneOffset);
    return renderTextLineClamp(
      formatToDate(timezoneDate),
      undefined,
      formatToDateTimeShort(timezoneDate)
    );
  }

  return renderTextLineClamp(
    formatToDate(date),
    undefined,
    formatToDateTimeShort(date)
  );
};
